<div>
	<h5 class="margin-top-0">{{ patientName | patientName }}</h5>
	@if (patientPopoverData) {
		<dl class='row margin-0'>
			<dt class="col-md-3">DOB</dt>
			<dd class="col-md-9">{{ patientPopoverData.dateOfBirth | date:dateFormat }}<br>({{ patientPopoverData.dateOfBirth | personAge }})
			</dd>
			<dt class="col-md-3">Sex</dt>
			<dd class="col-md-9">{{ patientPopoverData.gender.label }}</dd>
			<dt class="col-md-3">Address</dt>
			<dd class="col-md-9">
				<pms-address-display [address]="patientPopoverData.address"></pms-address-display>
			</dd>
			<dt class="col-md-3">Home</dt>
			<dd class="col-md-9">{{ patientPopoverData.phoneNumbers.homePhone }} {{ patientPopoverData.phoneNumbers.homePhoneExt }}
				@if (isPreferredPhoneType(preferredPhoneType.HOME)) {
					<i
						class='fa fa-star text-success'></i>
				}</dd>
			<dt class="col-md-3">Work</dt>
			<dd class="col-md-9">{{ patientPopoverData.phoneNumbers.workPhone }} {{ patientPopoverData.phoneNumbers.workPhoneExt }}
				@if (isPreferredPhoneType(preferredPhoneType.WORK)) {
					<i
						class='fa fa-star text-success'></i>
				}</dd>
			<dt class="col-md-3">Cell</dt>
			<dd class="col-md-9">{{ patientPopoverData.phoneNumbers.cellPhone }} {{ patientPopoverData.phoneNumbers.cellPhoneExt }}
				@if (isPreferredPhoneType(preferredPhoneType.CELL)) {
					<i
						class='fa fa-star text-success'></i>
				}</dd>
			<dt class="col-md-3">Email</dt>
			<dd class="col-md-9">{{ patientPopoverData.email }}</dd>
			<dt class="col-md-3">PHR Login</dt>
			<dd class="col-md-9">{{ patientPopoverData.phrLogin | yesNo }}</dd>
		</dl>
	}
</div>
